module.exports = __webpack_public_path__ + "static/media/EC.ec3cb23f.svg";